import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Country, State, City } from 'country-state-city';
import { ToastContainer, toast } from 'react-toastify';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import ApiProvider from "../../apiProvider/contactusApi"
import faceBookLogo from "../../assets/facebook-icon.png"
import instagramLogo from "../../assets/instagram.png"
import linkedInLogo from "../../assets/linkedIn.png"
import { useTranslation } from "../../context/TranslationContext";

import { Helmet } from 'react-helmet-async';

const countryList = Country.getAllCountries();

const contactusSchema = Yup.object().shape({
    fullName: Yup.string()
        .matches(/^[A-Za-z\s]+$/, 'Full name should accept only alphabets')
        .required('Full name is required'),
    phone: Yup.string()
        .matches(/^[0-9]{10}$/, 'Phone number must be exactly 10 digits')
        .required('Phone no is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    country: Yup.string().required("Country is required"),
});

const ContactPage = () => {
    const navigate = useNavigate();
    const { translateSync, currentLanguage, setCurrentLanguage } = useTranslation();

    const formSubmit = async (value) => {
        try {
            const input = {
                fullName: value.fullName,
                phone: value.phone,
                email: value.email,
                country: value.country,
                message: value.message
            }
            console.log(input, "input");
            const result = await ApiProvider.contactus(input)
            console.log(result, "result");
            if (result && result.response && result.status == 200) {
                // navigate("/login")
                if (window.gtag) {
                    window.gtag('event', 'contact_click', { contact_type: 'form', page_location: window.location.href });
                }
            }

        } catch (error) { }
    }
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>


            <Helmet>
                <title>Contact Colours Boutique | Saree Enquiries and Support</title>
                <meta name="description" content="Contact Colours Boutique for saree enquiries, order support, delivery details, and general assistance." />
                <link rel="canonical" href="https://coloursboutique.com/contact" />
            </Helmet>
            <div className="home-saree-container">
                <section className="contact-header-section text-center" style={{ paddingTop: "150px", paddingBottom: "20px" }}>
                    <div className="container">
                        <h1 className="fw-bold display-5 font-51" style={{ color: "#3a3530" }}>{translateSync('Contact Colours Boutique')}</h1>
                        <nav aria-label="breadcrumb" className="boutique-breadcrumb-nav center-align">
                            <ol className="boutique-breadcrumb-ol boutique-breadcrumb-center">
                                <li className="breadcrumb-item"><span onClick={() => navigate("/")}>{translateSync('Home')}</span></li>
                                <li className="breadcrumb-item active">{translateSync('Contact Us')}</li>
                            </ol>
                        </nav>
                    </div>
                </section>
                {/* Training That Transforms Section */}
                <section className="training-transforms-section py-5 ">
                    <div className="container-fluid">
                        {/* Section Title */}
                        {/* <h2 className="fw-bold text-center text-bg-light-color">Training That Transform</h2>
                    <p className="text-center px-md-5 mb-4">
                        Our programs go beyond traditional learning by combining cutting-edge strategies,
                        real-world applications, and expert guidance to create lasting impact.
                    </p> */}

                        <div className="row align-items-stretch">
                            {/* Left Side - Image (Full Height) */}
                            <div className="col-md-6 left-side-img" data-aos="fade-right" data-aos-delay="200">
                                <img
                                    src="/img/contact-new.jpeg"
                                    alt="Training"
                                    className="img-fluid rounded"
                                />
                            </div>

                            {/* Right Side - List Items (Full Height) */}
                            <div className="col-md-6 text-left  justify-content-between" data-aos="fade-right" data-aos-delay="200">

                                <div className="contactpage-content">
                                    <h2 className="fw-bold text-center  mb-1 " data-aos="fade-up" data-aos-delay="200">{translateSync('Get in Touch')}</h2>

                                    <p className=" text-center mb-10 " data-aos="fade-up" data-aos-delay="300">{translateSync("Fill out the form and we'll be in touch soon!")}</p>

                                    <Formik
                                        initialValues={{
                                            fullName: '',
                                            email: '',
                                            phone: '',
                                            country: '',
                                            message: ''
                                        }}
                                        validationSchema={contactusSchema}
                                        onSubmit={(values, { resetForm }) => {
                                            formSubmit(values);
                                            resetForm();
                                        }}
                                    >
                                        {({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
                                            <Form>
                                                <div className="row mt-6">
                                                    <div className="col-6 contactfieldd mb-4 text-start" data-aos="fade-up" data-aos-delay="200">
                                                        <input
                                                            name="fullName"
                                                            onChange={(e) => {
                                                                const value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                                                                setFieldValue('fullName', value);
                                                            }}
                                                            onBlur={handleBlur}
                                                            value={values.fullName}
                                                            type="text"
                                                            placeholder={translateSync('Enter your Full Name')}
                                                            className='form-control'
                                                        />
                                                        <span>
                                                            {errors.fullName && touched.fullName && <div className="error_msg">{translateSync(errors.fullName)}</div>}
                                                        </span>
                                                    </div>
                                                    <div className="col-6 contactfieldd mb-4 text-start" data-aos="fade-up" data-aos-delay="200">
                                                        <input
                                                            name="phone"
                                                            onChange={(e) => {
                                                                const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
                                                                setFieldValue('phone', value);
                                                            }}
                                                            onBlur={handleBlur}
                                                            value={values.phone}
                                                            type="text"
                                                            placeholder={translateSync("Phone Number")}
                                                            className='form-control'
                                                        />
                                                        <span>
                                                            {errors.phone && touched.phone && <div className="error_msg">{translateSync(errors.phone)}</div>}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className=" col-6 contactfieldd mb-4 text-start " data-aos="fade-up" data-aos-delay="200">
                                                        <input
                                                            name="email"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.email}
                                                            type="email"
                                                            placeholder={translateSync("Enter your Mail")}
                                                            className='form-control'
                                                        />
                                                        <span>
                                                            {errors.email && touched.email && <div className="error_msg">{translateSync(errors.email)}</div>}
                                                        </span>
                                                    </div>

                                                    <div className=" col-6 contactfieldd mb-4 text-start" data-aos="fade-up" data-aos-delay="200">
                                                        <select
                                                            className='form-control'
                                                            style={{ height: "50px" }}
                                                            name="country"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.country}
                                                        >
                                                            <option value="">{translateSync('Select a country')}</option>
                                                            {countryList.length > 0 ?
                                                                countryList.map((country, i) => {
                                                                    return (
                                                                        <option key={i} value={country.name}>
                                                                            {country.name}
                                                                        </option>
                                                                    )
                                                                })
                                                                :
                                                                <option>No records</option>
                                                            }
                                                        </select>
                                                        <span>
                                                            {errors.country && touched.country && <div className="error_msg">{translateSync(errors.country)}</div>}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className=" col-12 contactfieldd mb-3 text-start mb-4">
                                                    <textarea
                                                        placeholder={translateSync("Enter Your Message ")}
                                                        style={{ height: "130px" }}
                                                        className='form-control'
                                                        name="message"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.message}
                                                    ></textarea>
                                                </div>

                                                <button className="rbt-btn contact-submit-btn-theme signup-btnnn input-size contacttform-btnn form-submit-btn w-100" type="submit">{translateSync('Submit')}</button>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>


                    </div>
                </section>





                <section className="mb-5">
                    <div className="container">
                        <div className="row g-4 align-items-stretch mt-5">
                            {/* Left Side - Image (Full Height) */}
                            <div className="col-md-4">
                                <div className="contactbox contactpage-address-part h-100 w-100" data-aos="fade-up" data-aos-delay="200">
                                    <img
                                        src="/img/locationn.png"
                                        alt="Training"
                                        style={{ width: "50px", height: "50px", padding: "10px" }}
                                        className="img-fluid wiggle-icon  iconabt-imgg contact-icon-theme"
                                        data-aos="zoom-in" data-aos-delay="200"
                                    />
                                    <h5 data-aos="fade-up" data-aos-delay="200">{translateSync('Address')}</h5>
                                    <p data-aos="fade-up" data-aos-delay="200">
                                        Chennai
                                    </p>
                                </div>
                            </div>

                            {/* Right Side - List Items (Full Height) */}
                            <div className="col-md-4 ">
                                <div className="contactbox contactpage-address-part h-100 w-100" data-aos="fade-up" data-aos-delay="200">
                                    <img
                                        src="/img/mail.png"
                                        alt="Training"
                                        style={{ width: "50px", height: "50px", padding: "10px" }}
                                        className="img-fluid wiggle-icon  iconabt-imgg contact-icon-theme"
                                        data-aos="zoom-in" data-aos-delay="200"
                                    />
                                    <h5 data-aos="fade-up" data-aos-delay="200">{translateSync('Email')}</h5>
                                    <p data-aos="fade-up" data-aos-delay="200">
                                        <a href="mailto:support@colorboutique.com" style={{ color: 'inherit', textDecoration: 'none' }}>support@colorboutique.com</a>
                                        <br />
                                        <a href="mailto:info@colorboutique.com" style={{ color: 'inherit', textDecoration: 'none' }}>info@colorboutique.com</a>
                                    </p>

                                </div>
                            </div>


                            {/* Right Side - List Items (Full Height) */}
                            <div className="col-md-4 ">
                                <div className="contactbox contactpage-address-part h-100 w-100" data-aos="fade-up" data-aos-delay="200">
                                    <img
                                        src="/img/call-sharp.png"
                                        alt="Training"
                                        style={{ width: "50px", height: "50px", padding: "10px" }}
                                        className="img-fluid wiggle-icon  iconabt-imgg contact-icon-theme"
                                        data-aos="zoom-in" data-aos-delay="200"
                                    />
                                    <h5 data-aos="fade-up" data-aos-delay="200">{translateSync('Phone Number')}</h5>
                                    <p data-aos="fade-up" data-aos-delay="200">
                                        <a href="tel:+918056262626" style={{ color: 'inherit', textDecoration: 'none' }}>+91 80562 62626</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="map-areaa" data-aos="fade-up" data-aos-delay="200">
                    <iframe src="https://maps.google.com/maps?q=Chennai&t=&z=12&ie=UTF8&iwloc=&output=embed" style={{ width: "100%", height: "500px", border: "0" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

                </section>



            </div >

        </>
    )
}

export default ContactPage;